import store from '@/store';
import { receiveProfile } from '@/actions/costapass';
import { deleteWalletDiscount } from '@/actions/search';
import shouldIgnoreWidgetUpdate from './shouldIgnoreWidgetUpdate';

/**
 * Handle CostaPass profile update from widget
 * @param {object} param0 - user, loyaltyName
 * @param {Object|null} param0.user - User data
 * @param {string} param0.loyaltyName - Loyalty program name
 */
const handleCostaPassProfileUpdate = ({ user, loyaltyName }) => {
  // ⚠️ PROTECTION: If unified account is enabled and has user data,
  // ignore widget events that would clear the state (user === null)
  // This prevents the legacy widget from overwriting unified account data
  if (!user && shouldIgnoreWidgetUpdate()) {
    // Widget is trying to clear the state, but unified account is managing it
    // Ignore this event to prevent state loss
    return;
  }

  if (!user) {
    // remove CostaPass wallet discount
    store.dispatch(deleteWalletDiscount('costapass'));
  }
  // update CostaPass profile anyway? (even if user is logged out)
  // ( receiveProfile will check again if user is logged in or not )
  store.dispatch(receiveProfile(user, loyaltyName));
};

export default handleCostaPassProfileUpdate;
